// Identidade visual MS — tokens de cor compartilhados entre o tema MUI,
// os styled-components e os estilos inline (sx).
export const brand = {
  navy: '#000515',
  navyGradient: 'linear-gradient(90deg, #000515 0%, #001033 65%, #0A2A6B 100%)',
  primary: '#005BFF',
  primaryDark: '#0047CC',
  // Usar apenas como brilho ou sobre fundo navy; reprova contraste AA sobre branco.
  glow: '#0A84FF',
  glowBorder: 'rgba(10, 132, 255, 0.35)',
  glowShadow: '0 0 24px rgba(10, 132, 255, 0.35)',
  white: '#FFFFFF',
  surface: '#F4F6FA',
  tint: '#EEF3FF',
  border: '#E3E8F2',
  textSecondary: '#5B6478',
  text: '#0B1324',
  cardShadow: '0 1px 3px rgba(11, 19, 36, 0.06)',
  status: {
    success: { bg: '#A8DDB5', fg: '#145C2C' },
    warning: { bg: '#FFE58A', fg: '#6B4500' },
    attention: { bg: '#FFC9A0', fg: '#7A3000' },
    info: { bg: '#B3CDFF', fg: '#0039A6' },
    error: { bg: '#F5A3A3', fg: '#8F1D14' },
    neutral: { bg: '#D9DEE7', fg: '#3F4757' },
  },
};
